import { gql } from "@apollo/client";

export const ENABLE_SSO_PROVIDER = gql`
  mutation EnableSSOProvider($input: EnableSSOProviderInput!) {
    enableSSOProvider(input: $input)
  }
`;
